'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DropdownComponent } from './component';
import { DropdownOptionComponent } from './dropdownoption/component';

@NgModule({
  imports     : [
    BrowserModule
  ],
  declarations: [DropdownComponent, DropdownOptionComponent],
  exports     : [DropdownComponent, DropdownOptionComponent]
})
export class LKDropdown {
}
